import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'

import {
    ButtonSmall,
    Info,
    sendClickSoundCommand,
    sendHoverSoundCommand,
} from 'react-wot-bootstrap'

import {
    disablePlayerMatching,
    requestVehicles,
    selectDefaultVehicles,
    setSelectedVehicles,
    updateVehiclesReadiness,
} from 'state/actions/players_matching'
import { requestClanUnits } from 'state/actions/clan_units'

import ClanUnitsChannel from 'channels/clan_units'
import { getReactiveUpdateUrl } from 'helpers/reactivity'
import { toRoman } from 'helpers'

import { UNIT_TYPES } from 'constants'

import DefaultTooltip from 'components/DefaultTooltip/DefaultTooltip'
import VehicleFilter from 'components/VehicleFilter/VehicleFilter'

import PlayersMatchingBattleModeFilter
    from '../../components/BattleModeFilter/containers/PlayersMatchingBattleModeFilter'
import BattleRoomsWrapper from '../../components/BattleRoomsWrapper/BattleRoomsWrapper'
import BattleRoomsSchedule from '../../components/BattleRoomsSchedule/BattleRoomsSchedule'

import PlayersMatchingButton from './components/PlayersMatchingButton/PlayersMatchingButton'
import VehiclesCarousel from './components/VehiclesCarousel/VehiclesCarousel'
import NoVehicles from './components/NoVehicles/NoVehicles'
import UnitsCarousel from './components/UnitsCarousel/UnitsCarousel'
import WaitingPopover from './components/WaitingPopover/WaitingPopover'

import { SORTIES_WITH_LEVEL } from 'helpers/i18n'
import { BATTLE_ROOMS_UNITS_LIST_BUTTON } from '../../constants'
import {
    INFO_FOR_LEGIONARY,
    JOIN_RANDOM_UNIT_AS_LEGIONARY,
    OWN_CLAN_UNITS,
    NO_OWN_CLAN_UNITS,
    SELECTED_VEHICLES_COUNT,

    AVAILABLE_DURING_CHALLENGES,
    FIND_UNITS_IN_UNITS_LIST,
    RESET_SELECTED_VEHICLES_TOOLTIP,
    INFO_TOOLTIP,
} from './translations'


import { UnitDataPropTypes, VehiclePropTypes } from '../../propTypes'
import { VEHICLES_NOT_SELECTED } from './components/PlayersMatchingButton/translations'
import LoadingScreen from 'components/LoadingScreen/LoadingScreen'

import styles from './PlayersMatchingView.scss'

const INVENTORY_REQUEST_INTERVAL = 3000

export class PlayersMatchingView extends React.Component {
    static propTypes = {
        showSchedule: PropTypes.bool,

        availableVehiclesCount: PropTypes.number.isRequired,
        enabledDuringChallenges: PropTypes.bool,
        isClanMember: PropTypes.bool.isRequired,
        isUnitsLoaded: PropTypes.bool.isRequired,
        playersMatchingInProgress: PropTypes.bool.isRequired,
        reactiveUpdateUrl: PropTypes.string,
        selectedVehicles: PropTypes.arrayOf(VehiclePropTypes),
        shouldLoadUnits: PropTypes.bool,
        showLoader: PropTypes.bool.isRequired,
        units: PropTypes.arrayOf(UnitDataPropTypes).isRequired,
        vehicleLevel: PropTypes.number.isRequired,

        requestClanUnits: PropTypes.func.isRequired,
        requestVehicles: PropTypes.func.isRequired,
        selectDefaultVehicles: PropTypes.func.isRequired,
        setSelectedVehicles: PropTypes.func.isRequired,
        updateVehiclesReadiness: PropTypes.func.isRequired,
        openUnitsList: PropTypes.func.isRequired,
    }

    static defaultProps = {
        selectedVehicles: [],
    }

    constructor(props) {
        super(props)

        this.updateChannel(props.reactiveUpdateUrl)

        this.selectVehicles = this.selectVehicles.bind(this)
        this.state = { hoveredUnitId: null }
    }

    componentWillMount() {
        Promise.all([
            this.requestVehicles(),
            this.props.requestClanUnits(!this.props.isUnitsLoaded),
        ]).then(
            () => this.props.selectDefaultVehicles()
        )
    }

    componentWillUnmount() {
        this.updateChannel(null)

        clearTimeout(this.requestInventoryTimer)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.reactiveUpdateUrl !== nextProps.reactiveUpdateUrl) {
            this.updateChannel(nextProps.reactiveUpdateUrl)
        }

        if (nextProps.shouldLoadUnits) {
            this.props.requestClanUnits()
        }
    }

    // we request full vehicles data and then poll only status
    async requestVehicles() {
        await this.props.requestVehicles()

        this.updateVehicles()
    }

    updateVehicles() {
        this.props.updateVehiclesReadiness()

        this.requestInventoryTimer = setTimeout(
            () => this.updateVehicles(),
            INVENTORY_REQUEST_INTERVAL
        )
    }

    updateChannel(url) {
        if (this.channel) {
            this.channel.disconnect()
        }
        if (url) {
            this.channel = new ClanUnitsChannel(url)
        }
    }

    renderOwnClanUnitsSection() {
        if (!this.props.isClanMember) return null

        if (!this.props.units || !this.props.units.length) {
            return (
                <div className={styles.ownClanUnitsHolder}>
                    <p className={styles.noOwnClanUnits}>
                        {NO_OWN_CLAN_UNITS}
                    </p>
                </div>
            )
        }
        const units = [...this.props.units].sort(
            (firstUnit, secondUnit) => secondUnit.created_at - firstUnit.created_at
        )
        return (
            <div className={styles.ownClanUnitsHolder}>
                <h2 className={styles.title}>
                    {OWN_CLAN_UNITS(units.length)}
                </h2>
                <UnitsCarousel units={units} />
            </div>
        )
    }

    selectVehicles(vehicle_cds, filter) {
        this.props.setSelectedVehicles(vehicle_cds, filter)
    }

    renderBattleModeTabContent() {
        if (this.props.enabledDuringChallenges) {
            const battleModeName = SORTIES_WITH_LEVEL(toRoman(this.props.vehicleLevel))
            return (
                <section className={styles.main}>
                    <div className={styles.availableDuringChallenges}>
                        {AVAILABLE_DURING_CHALLENGES(battleModeName)}
                        {FIND_UNITS_IN_UNITS_LIST}
                        <div className={styles.battleRoomsButton}>
                            <ButtonSmall
                                type='secondary'
                                onClick={this.props.openUnitsList}
                            >
                                {BATTLE_ROOMS_UNITS_LIST_BUTTON}
                            </ButtonSmall>
                        </div>
                    </div>
                </section>
            )
        }

        if (this.props.showSchedule) {
            return (
                <section className={styles.main}>
                    <BattleRoomsSchedule
                        unitType={UNIT_TYPES.SORTIE}
                        vehicleLevel={this.props.vehicleLevel}
                    />
                </section>
            )
        }

        if (this.props.availableVehiclesCount === 0) {
            return (
                <section className={styles.main}>
                    <NoVehicles level={this.props.vehicleLevel}/>
                    <div className={styles.submitButton}>
                        <PlayersMatchingButton />
                    </div>
                </section>
            )
        }

        const isAnyVehicleSelected = this.props.selectedVehicles.length > 0

        const selectedVehiclesCounter = (
            <div className={styles.selectedVehiclesCounter}>
                {SELECTED_VEHICLES_COUNT(
                    this.props.selectedVehicles.length, this.props.availableVehiclesCount
                )}
            </div>
        )

        let resetSelectedVehiclesButton = null
        if (this.props.selectedVehicles.length !== this.props.availableVehiclesCount) {
            resetSelectedVehiclesButton = (
                <button
                    className={styles.resetSelectedVehiclesButton}
                    onClick={() => this.props.selectDefaultVehicles(true)}
                    onMouseDown={sendClickSoundCommand}
                    onMouseEnter={sendHoverSoundCommand}
                    data-tip data-for={RESET_SELECTED_VEHICLES_TOOLTIP.id}
                />
            )
        }

        return (
            <section className={styles.main}>
                <div className={styles.vehiclesFilter}>
                    <VehicleFilter onSelect={this.selectVehicles} />
                    {selectedVehiclesCounter}
                    {resetSelectedVehiclesButton}
                    <DefaultTooltip {...RESET_SELECTED_VEHICLES_TOOLTIP} />
                </div>
                {isAnyVehicleSelected ?
                    <VehiclesCarousel /> :
                    <span className={styles.vehiclesNotSelectedMessage}>
                        {VEHICLES_NOT_SELECTED}
                    </span>
                }
                <div className={styles.submitButton}>
                    <PlayersMatchingButton />
                </div>
                {this.props.playersMatchingInProgress && <WaitingPopover />}
            </section>
        )
    }

    render() {
        if (this.props.showLoader) {
            return <LoadingScreen type='fullscreen' />
        }

        const mainContent = this.renderBattleModeTabContent()

        let body = null
        if (this.props.isClanMember) {
            body = (
                <div className={styles.base}>
                    {this.renderOwnClanUnitsSection()}
                    <h2 className={styles.title}>
                        {JOIN_RANDOM_UNIT_AS_LEGIONARY}
                        <span className={styles.infoIcon}>
                            <Info tooltipId={INFO_TOOLTIP.id} />
                        </span>
                        <DefaultTooltip {...INFO_TOOLTIP} />
                    </h2>
                    <div className={styles.battleModeTabs}>
                        <PlayersMatchingBattleModeFilter />
                    </div>
                    {mainContent}
                </div>
            )
        } else {
            const baseClassName = classNames(styles.base, styles.base__nonClanMember)
            body = (
                <div className={baseClassName}>
                    <div className={styles.header}>
                        <div className={styles.battleModeTabs}>
                            <PlayersMatchingBattleModeFilter />
                        </div>
                        {INFO_FOR_LEGIONARY}
                        <span className={styles.infoIcon}>
                            <Info tooltipId={INFO_TOOLTIP.id} />
                        </span>
                        <DefaultTooltip {...INFO_TOOLTIP} />
                    </div>
                    <div className={styles.wrapper}>
                        {mainContent}
                    </div>
                </div>
            )
        }

        return (
            <BattleRoomsWrapper>
                {body}
            </BattleRoomsWrapper>
        )
    }
}

export const mapStateToProps = ({ clan, clanUnits, players_matching, settings }) => {
    const showLoader = clanUnits.showLoader || players_matching.loading || !players_matching.selected_vehicle_cds
    const clanUnitsChannelUrl = clan.units_channel
    const reactiveUpdateUrl = getReactiveUpdateUrl(settings.pushStreamHost, clanUnitsChannelUrl)
    const { selected_vehicle_cds } = players_matching

    const selectedVehicles = selected_vehicle_cds ?
        players_matching.vehicles.filter(vehicle => selected_vehicle_cds.includes(vehicle.id)) :
        players_matching.vehicles

    const vehiclesBySelectedLevel = players_matching.vehicles.filter(
        vehicle => vehicle.level === players_matching.vehicle_level
    )

    const playersMatchingSettings = players_matching.sortie_settings.find(
        setting => setting.level === players_matching.vehicle_level
    )

    return {
        availableVehiclesCount: vehiclesBySelectedLevel.length,
        enabledDuringChallenges: (
            playersMatchingSettings && playersMatchingSettings.show_challenges_message
        ),
        isClanMember: clan.id !== null,
        isUnitsLoaded: clanUnits.loaded,
        playersMatchingInProgress: players_matching.start_time !== null,
        reactiveUpdateUrl,
        selectedVehicles,
        shouldLoadUnits: !clanUnits.loaded && !clanUnits.loading,
        showLoader,
        units: clanUnits.units,
        vehicleLevel: players_matching.vehicle_level,
    }
}

export const mapDispatchToProps = {
    requestClanUnits,
    requestVehicles,
    selectDefaultVehicles,
    setSelectedVehicles,
    openUnitsList: disablePlayerMatching,
    updateVehiclesReadiness,
}

export default connect(mapStateToProps, mapDispatchToProps)(PlayersMatchingView)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/PlayersMatchingView.jsx